<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-img alt="Landing Image" src="../assets/landing_image.svg"></v-img>
    </v-col>
    <v-col cols="12" md="6" class="mt-8">
      <p class="display-2 primary--text">Submitify</p>
      <p class="headline primary--text">Mempermudah pengiriman dan pengelolaan tugas</p>
      <v-btn color="primary mt-8" to="/sign">Sign IN/ Sign Up</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Home',
};
</script>
